// extracted by mini-css-extract-plugin
export default {"text-blue":"#1b71f1","button":"show_more_btn_button__PxJyo"};